import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompleteForm_TimeslotsQueryVariables = Types.Exact<{
  input: Types.CompletionScheduleInstancesInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type CompleteForm_TimeslotsQuery = { __typename?: 'Query', CompletionScheduleInstances: { __typename?: 'CompletionScheduleInstances', totalCount: number, objects: Array<{ __typename?: 'CompletionScheduleInstance', id: string, start: DateTimeUtc, end: DateTimeUtc, lateDeadline?: DateTimeUtc | null, status: Types.CompletionScheduleInstanceStatus, completedBySkillInstance?: { __typename?: 'SkillInstance', id: string } | null, location: { __typename?: 'Location', id: number, address?: { __typename?: 'Address', id: string, timezoneStr?: string | null } | null } }> } };

export type CompleteForm_OrgTimeZoneQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CompleteForm_OrgTimeZoneQuery = { __typename?: 'Query', Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, org?: { __typename?: 'Org', id: number, timezone: Types.Timezone } | null } } | null };

export type CompleteForm_FindTimeslotDraftMutationVariables = Types.Exact<{
  input: Types.GetOrCreateTaskListInstanceDraftInput;
}>;


export type CompleteForm_FindTimeslotDraftMutation = { __typename?: 'Mutation', getOrCreateTaskListInstanceDraft: { __typename?: 'SkillInstanceMutationResult', skillInstance?: { __typename?: 'SkillInstance', id: string, startedAt?: string | null } | null } };

export type CompleteForm_TimeslotFragment = { __typename?: 'CompletionScheduleInstance', id: string, start: DateTimeUtc, end: DateTimeUtc, lateDeadline?: DateTimeUtc | null, status: Types.CompletionScheduleInstanceStatus, completedBySkillInstance?: { __typename?: 'SkillInstance', id: string } | null, location: { __typename?: 'Location', id: number, address?: { __typename?: 'Address', id: string, timezoneStr?: string | null } | null } };

export const CompleteForm_TimeslotFragmentDoc = gql`
    fragment CompleteForm_Timeslot on CompletionScheduleInstance {
  id
  start
  end
  lateDeadline
  status
  completedBySkillInstance {
    id
  }
  location {
    id
    address {
      id
      timezoneStr
    }
  }
}
    `;
export const CompleteForm_TimeslotsDocument = gql`
    query CompleteForm_Timeslots($input: CompletionScheduleInstancesInput!, $pagination: PaginationInput) {
  CompletionScheduleInstances(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...CompleteForm_Timeslot
    }
  }
}
    ${CompleteForm_TimeslotFragmentDoc}`;

/**
 * __useCompleteForm_TimeslotsQuery__
 *
 * To run a query within a React component, call `useCompleteForm_TimeslotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompleteForm_TimeslotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompleteForm_TimeslotsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCompleteForm_TimeslotsQuery(baseOptions: Apollo.QueryHookOptions<CompleteForm_TimeslotsQuery, CompleteForm_TimeslotsQueryVariables> & ({ variables: CompleteForm_TimeslotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompleteForm_TimeslotsQuery, CompleteForm_TimeslotsQueryVariables>(CompleteForm_TimeslotsDocument, options);
      }
export function useCompleteForm_TimeslotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompleteForm_TimeslotsQuery, CompleteForm_TimeslotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompleteForm_TimeslotsQuery, CompleteForm_TimeslotsQueryVariables>(CompleteForm_TimeslotsDocument, options);
        }
export type CompleteForm_TimeslotsQueryHookResult = ReturnType<typeof useCompleteForm_TimeslotsQuery>;
export type CompleteForm_TimeslotsLazyQueryHookResult = ReturnType<typeof useCompleteForm_TimeslotsLazyQuery>;
export type CompleteForm_TimeslotsQueryResult = Apollo.QueryResult<CompleteForm_TimeslotsQuery, CompleteForm_TimeslotsQueryVariables>;
export const CompleteForm_OrgTimeZoneDocument = gql`
    query CompleteForm_OrgTimeZone {
  Me {
    user {
      id
      org {
        id
        timezone
      }
    }
  }
}
    `;

/**
 * __useCompleteForm_OrgTimeZoneQuery__
 *
 * To run a query within a React component, call `useCompleteForm_OrgTimeZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompleteForm_OrgTimeZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompleteForm_OrgTimeZoneQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompleteForm_OrgTimeZoneQuery(baseOptions?: Apollo.QueryHookOptions<CompleteForm_OrgTimeZoneQuery, CompleteForm_OrgTimeZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompleteForm_OrgTimeZoneQuery, CompleteForm_OrgTimeZoneQueryVariables>(CompleteForm_OrgTimeZoneDocument, options);
      }
export function useCompleteForm_OrgTimeZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompleteForm_OrgTimeZoneQuery, CompleteForm_OrgTimeZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompleteForm_OrgTimeZoneQuery, CompleteForm_OrgTimeZoneQueryVariables>(CompleteForm_OrgTimeZoneDocument, options);
        }
export type CompleteForm_OrgTimeZoneQueryHookResult = ReturnType<typeof useCompleteForm_OrgTimeZoneQuery>;
export type CompleteForm_OrgTimeZoneLazyQueryHookResult = ReturnType<typeof useCompleteForm_OrgTimeZoneLazyQuery>;
export type CompleteForm_OrgTimeZoneQueryResult = Apollo.QueryResult<CompleteForm_OrgTimeZoneQuery, CompleteForm_OrgTimeZoneQueryVariables>;
export const CompleteForm_FindTimeslotDraftDocument = gql`
    mutation CompleteForm_FindTimeslotDraft($input: GetOrCreateTaskListInstanceDraftInput!) {
  getOrCreateTaskListInstanceDraft(input: $input) {
    skillInstance {
      id
      startedAt
    }
  }
}
    `;
export type CompleteForm_FindTimeslotDraftMutationFn = Apollo.MutationFunction<CompleteForm_FindTimeslotDraftMutation, CompleteForm_FindTimeslotDraftMutationVariables>;

/**
 * __useCompleteForm_FindTimeslotDraftMutation__
 *
 * To run a mutation, you first call `useCompleteForm_FindTimeslotDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteForm_FindTimeslotDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeFormFindTimeslotDraftMutation, { data, loading, error }] = useCompleteForm_FindTimeslotDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteForm_FindTimeslotDraftMutation(baseOptions?: Apollo.MutationHookOptions<CompleteForm_FindTimeslotDraftMutation, CompleteForm_FindTimeslotDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteForm_FindTimeslotDraftMutation, CompleteForm_FindTimeslotDraftMutationVariables>(CompleteForm_FindTimeslotDraftDocument, options);
      }
export type CompleteForm_FindTimeslotDraftMutationHookResult = ReturnType<typeof useCompleteForm_FindTimeslotDraftMutation>;
export type CompleteForm_FindTimeslotDraftMutationResult = Apollo.MutationResult<CompleteForm_FindTimeslotDraftMutation>;
export type CompleteForm_FindTimeslotDraftMutationOptions = Apollo.BaseMutationOptions<CompleteForm_FindTimeslotDraftMutation, CompleteForm_FindTimeslotDraftMutationVariables>;